import React from 'react'
import MethodItem from './MethodItem'
import DynamicColor from '../../common/dynamic-color'

import { COLOR_NAME, ORDER_METHOD } from '../../../constants'

import IconDelivery from '../../../assets/images/delivery.png'
import IconRestaurant from '../../../assets/images/pickup.png'
import { useTranslation } from 'react-i18next'

const SelectMethod = ({ onChooseMethod }) => {
    const { t } = useTranslation()
    return (
        <>
            <DynamicColor
                style={{ color: COLOR_NAME.MODAL_TEXT }}
                className="method-title text-center"
            >
                <b>{t('modalOrderMethod.title')}</b>
            </DynamicColor>

            <div className="wrap-menu-list">
                <div className="method-list">
                    <MethodItem
                        onClick={() => onChooseMethod(ORDER_METHOD.DELIVERY)}
                        title={t('modalOrderMethod.lbDeliver')}
                        image={IconDelivery}
                    />
                    <MethodItem
                        onClick={() => onChooseMethod(ORDER_METHOD.PICKUP)}
                        title={t('modalOrderMethod.lbPickup')}
                        image={IconRestaurant}
                    />
                </div>
            </div>
        </>
    )
}

export default SelectMethod
